// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-shadow[data-v-a423d5d8]{padding-left:1rem;padding-right:1rem}.modal-shadow[data-v-a423d5d8] .modal-content{border-radius:.375rem;border-width:2px;--tw-border-opacity:1;border-color:rgba(0,0,0,var(--tw-border-opacity));--tw-shadow:4px 4px 0px 0px #212429;box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
